import AuthLayout from "@/layout/auth/AuthLayout.vue";

export default [
  {
    path: "/auth",
    component: AuthLayout,
    children: [
      {
        path: "login",
        name: "login",
        component: () =>
          import(
            /* webpackChunkName: "system" */ "@/views/pages/Login.vue"
          ),
      },
      {
        path: "access-denied",
        name: "access-denied",
        component: () =>
          import(
            /* webpackChunkName: "system" */ "@/views/pages/AccessDenied.vue"
          ),
      },
      {
        path: "callback",
        name: "oauth-callback",
        component: () =>
          import(
            /* webpackChunkName: "system" */ "@/views/pages/OAuthCallback.vue"
          ),
      },
    ],
  },
];
